import { css } from '@emotion/core'
import { colors, measures, zIndexes } from 'styles/variables'

const { half } = measures
export const container = css`
  display: inline-block;
  color: white;
  position: relative;
`

export const trigger = css`
  cursor: pointer;
  color: white;
  text-decoration: underline;
`

export const optionsList = css`
  background-color: ${colors.blues.blue1};
  position: absolute;
  border-radius: ${half}px;

  text-align: center;
  top: 100%;

  width: 100%;

  z-index: ${zIndexes.dropdown};
`

export const item = css`
  cursor: pointer;
  width: 100%;
  padding: ${half}px;
  padding-bottom: ${half / 2}px;
  color: ${colors.white100};
  :last-of-type {
    padding-bottom: ${half}px;
  }

  :first-of-type {
    padding-bottom: ${half}px;
  }

  :hover {
    border-bottom: 1px solid ${colors.greens.green6};
    color: ${colors.greens.green6};
  }
`
